import React from 'react';
import '../css/projectEntry.css';


interface ProjectEntryProps {
    name: string,
    link: string,
    codelink?: string,
    additionalLink?: { text: string, url: string }
    wip?: boolean,
    date?: string,
    description?: string,
    duration?: string,
}

const ProjectEntry: React.FC<ProjectEntryProps> = ({ name, link, codelink, additionalLink, wip, date, description, duration }) => {
    return (
        <div className={'project-entry'}>
            <a href={link} className={'project-name-link'} target="_blank" rel="noopener noreferrer">
                {name}
            </a>
            &nbsp;
            {date ? <div className={'project-date-string'}>({date})</div> : null}
            {wip ? <>&nbsp;(Work in progress)</> : null}
            {codelink ? <>&nbsp;(<a href={codelink} target="_blank" rel="noopener noreferrer">
                code
            </a>)</> : null}
            {description ? (
                <>
                    <br />
                    <div className={'project-description'}>{description}</div>
                </>
            ) : null}
            {additionalLink ? (
                <>
                    <div className={'project-additional-link'}>
                        <a href={additionalLink.url} target="_blank" rel="noopener noreferrer">
                            {additionalLink.text}
                        </a>
                    </div>
                </>
            ) : null}
            {duration ? (
                <>
                    <div className={'project-duration'}>{duration}</div>
                </>
            ) : null}
        </div>
    );
};

export default ProjectEntry;